import React from "react";
import { Menu, Grid, Container } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import BreadcrumbContainer from "../../app/common/breadcrumb/BreadcrumbContainer";
import { sectionHome } from "../../app/util/breadcrumbOptions";

const Configuration: React.FC = () => {
  let navigate = useNavigate();

  const match = {
    url: '/home/Configuration',
  }

  document.title = "Configuración";
  return (
    <div>
      <div className="configurationContent">
        <BreadcrumbContainer title="Configuración" sections={sectionHome} />
      </div>
      <div className="configurationContent">
        <Grid columns={2} stackable textAlign="center">
          <Grid.Row verticalAlign="top">
            <Grid.Column>
              <Menu vertical fluid className="configurationMenu">
                <Menu.Item header className="firstLineConfig">Mi empresa</Menu.Item>
                <Menu.Item
                  name="Configuración general"
                  onClick={() => navigate(`${match.url}/DashboardSupplier`)}
                >
                  <Container textAlign="left">Configuración general</Container>
                </Menu.Item>

                <Menu.Item
                  name="Usuarios"
                  onClick={() => navigate(`${match.url}/DashboardUsers`)}
                >
                  <Container textAlign="left">Usuarios</Container>
                </Menu.Item>
              </Menu>
            </Grid.Column>

            <Grid.Column key="configurat">
              <Menu vertical fluid className="configurationMenu">
                <Menu.Item header className="firstLineConfig">Resoluciones/Certificado digital</Menu.Item>
                <Menu.Item
                  name="resaluciones"
                  onClick={() =>
                    navigate(`${match.url}/ElectronicResolutions`)
                  }
                >
                  <Container textAlign="left">
                    Resoluciones facturación electrónica
                  </Container>
                </Menu.Item>

                <Menu.Item
                  name="certificado"
                  onClick={() =>
                    navigate(`${match.url}/DigitalCertificate`)
                  }
                >
                  <Container textAlign="left">Certificado digital</Container>
                </Menu.Item>
              </Menu>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row verticalAlign="middle">
            <Grid.Column>
              <Menu vertical fluid className="configurationMenu">
                <Menu.Item header className="firstLineConfig">Set de pruebas</Menu.Item>
                <Menu.Item
                  name="pruebas"
                  onClick={() => navigate(`${match.url}/SetDian-v2`)}
                >
                  <Container textAlign="left" fluid>
                    Ejecuta el set de pruebas con la DIAN
                  </Container>
                </Menu.Item>
              </Menu>
            </Grid.Column>
            <Grid.Column></Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </div>
  );
};

export default Configuration;
